export const getInputBorderClass = (isActive) => {
    return isActive ? 'border border-primary' : 'border border-lighterGray';
  };
  
  export const getInputBackgroundClass = (isActive) => {
    return isActive ? 'bg-white' : 'bg-secondary';
  };
  
  export const getIconColorClass = (isActive) => {
    return isActive ? 'text-black' : 'text-gray-400';
  };
  
  export const getFocusClasses = () => {
    return 'focus:outline-none focus:ring-0 focus:border-primary';
  };
  
  export const getTransitionClasses = () => {
    return 'transition duration-150 ease-in-out';
  };
  
  
  export const getLabelClasses = (isActive) => {
    return `absolute top-1 left-3 text-small font-semibold ${isActive ? 'text-black' : 'text-gray-600'} uppercase z-10`;
  };
  
  // New utility for placeholder styling
  export const getPlaceholderClasses = (isActive) => {
    return `pointer-events-none ${isActive ? 'text-black' : 'text-gray-400'} z-10`;
  };
  
  // Common padding and sizing classes
  export const getBasePaddingClasses = (hasIcon) => {
    return `py-6 ${hasIcon ? 'pl-12' : 'pl-3'} pr-10`;
  };
  
  // Reusable utility to determine if input is in "active" state
  export const isInputActive = (value, isFocused) => {
    return Boolean(value) || isFocused;
  };